module.exports = __webpack_public_path__ + "images/wxwork/img-wcwf-3@2x-8ae233cf0b37c022de49bd302b76f045.png";